import { BarChart } from "@mantine/charts";
import { Flex } from "@mantine/core";

import type { JSX } from "react";

export function OtherPlansChart(): JSX.Element {
    const data = [
        { plan: "5G", sales: 2, compliment: 0 },
        { plan: "Accessories", sales: 4, compliment: 0 },
        { plan: "Add-a-line", sales: 5, compliment: 0 },
        { plan: "Fios", sales: 6, compliment: 0 },
        { plan: "VMP", sales: 1, compliment: 0 },
        { plan: "Upgrade", sales: 10, compliment: 0 },
    ];
    const largestSale = Math.ceil(Math.max(...data.map((d) => d.sales)) * 1.1);

    data.forEach((d) => {
        d.compliment = largestSale - d.sales;
    });

    return (
        <Flex>
            <BarChart
                p="md"
                maxBarWidth={50}
                type="stacked"
                yAxisProps={{ domain: [0, largestSale] }}
                h={300}
                yAxisLabel="Sales"
                data={data}
                dataKey="plan"
                series={[
                    { name: "sales", color: "primary.4" },
                    { name: "compliment", color: "#333F4833" },
                ]}
            ></BarChart>
        </Flex>
    );
}
